
import Pricing from 'components/pricing/Pricing.jsx'

export default function PricingPage(){
  return(
    <Pricing />
  )
}

export async function getStaticProps() {
  return {
    props: {
      meta: {
        title: "Datopian Pricing",
        description: "Discover Datopian's pricing plans, offering robust and scalable CKAN hosting and support services, designed to power your organization's data needs efficiently.",
      },
    },
  };
};